<div class="pilot-pay-admin-dashboard">
	<div fxLayoutWrap="wrap">
		<mat-card>
			<mat-card-title fxLayout="row" fxLayoutAlign="start center">
				<h5 class="readonly-label">
					Monthly Time Sheet Overview for
					<mat-select class="header-select" [(value)]="selectedDateSerialized">
						<mat-option
							class="header-item"
							*ngFor="let t of payPeriods"
							(click)="onDateChange(t)"
							[value]="t"
						>
							{{ t | date: 'MMMM y' }}
							<span *ngIf="t == currentDate">(Current)</span>
							<span *ngIf="t == previousDate">(Previous)</span>
						</mat-option>
					</mat-select>
				</h5>
				<span fxFlex></span>
			</mat-card-title>
			<mat-card-content
				class="admin-dashboard-graphs"
				[ngClass]="[areAllTimeSheetsPaid ? 'submitTimeSheet2' : '']"
			>
				<div *ngIf="areAllTimeSheetsPaid" class="mt-1 mb-1" fxLayout="row" fxLayoutAlign="space-around center">
					<h5 class="readonly-label">
						<i class="fa fa-check" aria-hidden="true"></i> All {{ paid }} Time Sheets have been Paid
					</h5>
				</div>
				<div *ngIf="!areAllTimeSheetsPaid" class="flex-container">
					<h5 class="readonly-label flex-item" *ngIf="tsSubmissionDeadline == 1">
						Time sheets are due in <span class="font-bold m-left"> {{ tsSubmissionDeadline }} Day</span>
					</h5>
					<h5 class="readonly-label flex-item" *ngIf="tsSubmissionDeadline == 0">
						Time sheets are due <span class="font-bold m-left"> today </span>
					</h5>
					<h5 class="readonly-label flex-item" *ngIf="tsSubmissionDeadline > 1">
						Time sheets are due in
						<span class="font-bold m-left"> {{ tsSubmissionDeadline }} Days</span>
					</h5>
					<h5 class="readonly-label flex-item" *ngIf="isAfterDeadlineWarning && passedSubmissionDue > 1">
						<span class="font-bold m-right-5">{{ selectedDateSerialized | date: 'MMMM' }}</span
						>time sheets <span class="font-bold">{{ passedSubmissionDue }}</span> days past due date
					</h5>
					<h5 class="readonly-label flex-item" *ngIf="isAfterDeadlineWarning && passedSubmissionDue == 1">
						<span class="font-bold m-right-5">{{ selectedDateSerialized | date: 'MMMM' }}</span
						>time sheets <span class="font-bold">{{ passedSubmissionDue }}</span> day past due date
					</h5>
					<h5 class="readonly-label flex-item">
						<span class="font-bold m-right">{{ notStarted }}</span
						>Not started
					</h5>
					<h5 class="readonly-label flex-item">
						<span class="font-bold m-right">{{ inProgress }}</span
						>In Progress
					</h5>
					<h5 class="readonly-label flex-item">
						<span class="font-bold m-right">{{ submittedByEmployee }}</span> Submitted
					</h5>
					<h5 class="readonly-label flex-item">
						<span class="font-bold m-right">{{ approvedByAdmin }}</span> Approved
					</h5>
					<h5 class="readonly-label flex-item">
						<span class="font-bold m-right">{{ paid }}</span> Paid
					</h5>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
	<div>
		<div *ngIf="isLoading" class="loading-container"></div>
		<app-pilots-table
			[hidden]="isLoading"
			[pilots]="pilots"
			[selectedDate]="selectedDate"
			(onExportPayroll)="exportToPayroll($event)"
		></app-pilots-table>
	</div>
</div>
